export const DISCOUNT_CREATE_EDIT_FORM_LOADING = {
    discountCreateEdit: {
        status: "LOADING",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: null
    }
};
export const DISCOUNT_CREATE_EDIT_FORM_CANCEL = () => ({
    discountCreateEdit: {
        status: "",
        meta: {
            title: '',
            button: '',
            type: ''
        },
        payload: null
    }
});
export const DISCOUNT_CREATE_EDIT_FORM_CREATE = () => ({
    discountCreateEdit: {
        status: "DONE",
        meta: {
            title: 'Create',
            button: 'save',
            type: 'create'
        },
        payload: null
    }
});
export const DISCOUNT_CREATE_EDIT_FORM_DONE = (payload) => ({
    discountCreateEdit: {
        status: "DONE",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: payload
    }
});
export const DISCOUNT_CREATE_EDIT_FORM_ERROR = (payload) => ({
    discountCreateEdit: {
        status: "ERROR",
        meta: {
            title: 'edit',
            button: 'save',
            type: 'edit'
        },
        payload: payload
    }
});
export const DISCOUNT_VIEW_BAR_SHOW = (payload) => ({
    discounts: payload
});
export const DISCOUNT_VIEW_BAR_LOADING = (payload) => ({
    discounts: payload
});
export const DISCOUNT_VIEW_BAR_DONE = (payload) => ({
    discounts: payload
});
export const DISCOUNT_VIEW_BAR_ERROR = (payload) => ({
    discounts: payload
});
export const SET_SELECTED_DISCOUNTS = (payload) => ({
    selectedDiscounts: payload
});
export const UPDATE_DISCOUNT_STATUS = (payload) => ({
    discounts: payload
});